<template>
    <div id="headseach">
         <el-input
            class="seachinput"
            placeholder="请输入"
            size="small"
            v-model="seachtitle">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="seach()"></i>
        </el-input>
    </div>
</template>
<script>
export default {
  name: 'headseach',
  props: {

  },
  data () {
    return {
      seachtitle: ''
    }
  },
  methods: {
    seach () {
      alert(this.seachtitle)
    }
  }
}
</script>
<style lang="less" scoped>
#headseach{
  margin-right: 10px;
    .seachinput{
      width: 200px;
    }
}
.el-input--suffix .el-input__inner{
    border-radius: 30px
}
.el-input__icon:hover{
    color: blue;
    font-weight: 700
}
</style>



// WEBPACK FOOTER //
// src/components/utils/HeadSeach.vue